import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { InteractionType, LocalService, PageKey, Status, TriggeredEvent, Wrappers10 } from 'src/service/local.service';
import { ReportService } from 'src/service/report.service';

@Component({
  selector: 'app-settlement-report',
  templateUrl: './settlement-report.component.html',
  styleUrl: './settlement-report.component.scss'
})
export class SettlementReportComponent {
  lstSectionConfigKeys: string[] = ["sales_report", "table"]; maxBodyHeight = 0;
  businessId: string = ''; ctryCode: string = ''; interactionType = 0;
  wrapper: Wrappers10; isOpenConfirmationBox: boolean = false;

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private route: ActivatedRoute, private languageManagementService: LanguageManagementService, private configurationManagementService: ConfigurationManagementService, private reportService: ReportService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = parseInt(routeParams.interactionType);
      this.businessId = routeParams.businessId;

      this.configurationManagementService.ensurePageActions(PageKey.SaleSettlement);

      if (this.interactionType != InteractionType.User && (this.businessId == '' || this.businessId == '0')) {
        this.localService.redirectToSeller();
      } else {
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId, false, this.interactionType == InteractionType.User ? routeParams.businessId : '');
        this.ctryCode = routeParams.ctryCode;
        this.businessId = routeParams.businessId ? routeParams.businessId : '';
        this.onLoad();
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    this.reportService.getSaleSettlements(this.businessId, this.wrapper ? this.wrapper.paging : null).subscribe(result => {
      this.wrapper = result;
    });
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        this.onSetSettlement(false);
      } break;
      case 2: {
        this.isOpenConfirmationBox = true;
      } break;
    }
  }

  onSetSettlement(isFinal: boolean) {
    this.reportService.setSaleSettlement(this.businessId, isFinal).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success) {
        this.onLoad();
      }
    });
  }

  onConfirmed(result: any) {
    this.isOpenConfirmationBox = false;
    if (result && result.event == TriggeredEvent.Ok) {
      this.onSetSettlement(true);
    }
  }
}
